import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { IrFormService } from 'src/app/services/ir-form/ir-form.service';
import { ProjectDTO } from 'src/app/models/project';
import { RI_STATUS_DESCRIPTION } from 'src/app/config';

@Component({
  selector: 'app-ir-approved',
  templateUrl: './ir-approved.component.html',
  styleUrls: ['./ir-approved.component.css']
})
export class IrApprovedComponent implements OnInit, OnDestroy {

  subscriptions: Subscription = new Subscription();
  irApproved: ProjectDTO[];
  translations: any;

  riStatus: RI_STATUS_DESCRIPTION;
  loader: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private irFormService: IrFormService
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(this.route?.data?.subscribe(data => {
      this.riStatus = data?.riStatus;
      this.loader = true;
      this.getIrApproved();
    }));
  }

  getIrApproved(): void {
    if (this.riStatus === RI_STATUS_DESCRIPTION.RiApproved) {
      this.subscriptions.add(this.irFormService.getProjectByStatusDescription(this.riStatus, true).subscribe((project: ProjectDTO[]) => {
        this.irApproved = project;
        this.loader = false;
      }));
    }
    if (this.riStatus === RI_STATUS_DESCRIPTION.IspWorking) {
      this.subscriptions.add(
        this.irFormService.getProjectApprovedByStatusDescription(this.riStatus, true).subscribe((project: ProjectDTO[]) => {
          this.irApproved = project;
          this.loader = false;
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
